import { SafeUrl } from "@angular/platform-browser";

export class SearchEngagementResultDto {
    JobId: number;
    JobCode: string;
    JobDescription: string;
    JobStatus: string;
    ClientNumber: string;
    ClientDescription: string;
    JobCategory: string;
}
export class SearchEngagementDto {
    SearchKey: string;
    InstanceId: number;
    JobId: number;
}